/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  ConsoleLogger.ts
 */

import { BaseLogger } from './BaseLogger'

const timestamp = () => new Date().toISOString()

export class ConsoleLogger extends BaseLogger {
  handleLog(...args: unknown[]): void {
    console.log(timestamp(), 'LOG', ...args)
  }

  handleDebug(...args: unknown[]): void {
    console.debug(timestamp(), 'DEBUG', ...args)
  }

  handleInfo(...args: unknown[]): void {
    console.info(timestamp(), 'INFO', ...args)
  }

  handleWarn(...args: unknown[]): void {
    console.warn(timestamp(), 'WARN', ...args)
  }

  handleError(...args: unknown[]): void {
    console.error(timestamp(), 'ERROR', ...args)
  }

  handleCritical(...args: unknown[]): void {
    console.error(timestamp(), 'CRITICAL', ...args)
  }
}
